module.exports = __webpack_public_path__ + "bigbox.4f0b789557032705c6bcff754b2c99e9.png";